import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import bdapi from "@bd-core/bd-api";

export const WelcomePage = () => {
    const isWelcomePage = $("#page-welcome").length > 0;
    if (!isWelcomePage) return false;

    bdjs.hideLoading();

    const onBackToSelection = () => {
        $(".welcome").removeClass("is-login");
    };

    const onInputTeamID = function (e, keepError) {
        if (keepError) return;

        const isDisabled = String($(this).val()).trim().length < 1;

        $(".js-join-btn").prop("disabled", isDisabled);
        $(".gameOptions").removeClass("is-join-error");
        $(".gameOptions").toggleClass("is-captcha-open", !isDisabled);
    };

    let isLoading = false;
    const onSubmitTeamID = async function () {
        if (isLoading) return false;
        const $joinBtn = $(".js-join-btn");
        const $inputTeamCode = $(".js-team-id");
        const $error = $(".gameOptions__joinError");
        const $gameOptions = $(".gameOptions");

        $joinBtn.addClass("is-loading").prop("disabled", true);
        $inputTeamCode.prop("readonly", true);
        $gameOptions.removeClass("is-join-error");

        isLoading = true;

        const [res, err] = await bdjs.goAsync(
            bdapi.post("public/join-team", {
                re_response: grecaptcha.getResponse(), // eslint-disable-line no-undef
                team_code: $(".js-team-id").val(),
            }),
        );

        isLoading = false;
        const restData = res?.data || {};

        if (restData?.data?.redirect) {
            $gameOptions.removeClass("is-captcha-open");
            bdjs.showLoading();
            window.location.href = restData.data.redirect;
            return;
        }

        grecaptcha.reset(); // eslint-disable-line no-undef

        if (!restData?.success || err) {
            const errMsg =
                restData?.data?.message ||
                "Something went wrong. Please try again!";
            $joinBtn.removeClass("is-loading").prop("disabled", false);
            $inputTeamCode.prop("readonly", false);
            $error.text(errMsg);
            $(".js-team-id").trigger("focus", { keepError: true });
            $gameOptions.addClass("is-join-error");
        }
    };

    const submitCreateTeam = async function ($triggeredButton) {
        if (isLoading) return false;
        const $button = $triggeredButton;
        $button.addClass("is-loading").prop("disabled", true);
        $snackBar.removeClass("is-active");

        isLoading = true;

        const [res] = await bdjs.goAsync(
            bdapi.post("public/create-new-team", {
                user_email: $(".js-login-email").val(),
            }),
        );

        isLoading = false;
        const restData = res?.data || {};

        if (restData?.data?.redirect) {
            bdjs.showLoading();
            window.location.href = restData.data.redirect;
            return;
        }

        const msg =
            restData?.data?.message ||
            "Something went wrong. Please try again!";
        $button.removeClass("is-loading").removeAttr("disabled");
        $snackBar.addClass("is-active").find(".snackbar__body").html(msg);
    };

    const onInputLoginEmail = function () {
        const value = String($(this).val());
        const isDisabled = value.trim().length < 1;
        $(".welcome__formSubmit").prop("disabled", isDisabled);
    };

    const onGotoLogin = function () {
        if (CONFIG.isAuth) {
            submitCreateTeam($(this));
        } else {
            $(".welcome").addClass("is-login");
        }
    };

    $(".js-create-game").on("click", onGotoLogin);
    $(".js-team-id").on("focus", onInputTeamID);
    $(".js-team-id").on("input", onInputTeamID);
    $(".js-join-btn").on("click", onSubmitTeamID);
    $(".js-login-email").on("input", onInputLoginEmail);
    $(".js-back").on("click", onBackToSelection);

    const $snackBar = $(".snackbar");

    // Snackbar Component
    // ------------------------------------------------------------------------
    $snackBar.find(".snackbar__close").on("click", function (e) {
        e.preventDefault();
        $snackBar.removeClass("is-active");
    });

    $("form.welcome__form").on("submit", function (e) {
        e.preventDefault();
        const $this = $(this);
        const $button = $this.find("button");
        submitCreateTeam($button);
        return false;
    });
};
